import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
var StatusNotStarted = function StatusNotStarted(props) {
  return /*#__PURE__*/ _jsx(
    "svg",
    _extends(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
      },
      props,
      {
        children: /*#__PURE__*/ _jsx("path", {
          d: "M10.45 2.55005C15.12 2.55005 18.9 6.33005 18.9 11C18.9 15.67 15.12 19.45 10.45 19.45C5.78 19.45 2 15.67 2 11C2 6.33005 5.78 2.55005 10.45 2.55005ZM10.45 0.550049C4.69 0.550049 0 5.24005 0 11C0 16.76 4.69 21.45 10.45 21.45C16.21 21.45 20.9 16.76 20.9 11C20.9 5.24005 16.22 0.550049 10.45 0.550049Z",
          fill: "#A4A7AE",
        }),
      }
    )
  );
};
export default StatusNotStarted;
